import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/voucher/conditions?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/voucher/conditions/${id}`, { params });
}

export async function create(body) {
  return request(`/voucher/conditions`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/voucher/conditions/${id}`, {
    method: 'POST',
    body,
  });
}